import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Grid, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import {
	ButtonLink,
	FormattedDateTimeRange,
	Icon,
	ImageAvatar,
	SquareChip,
	TagsArray,
	Text,
	useSettings
} from 'app/main/components';
import buttons from './CommunicationsButtons';

export default function CommunicationsListItem(props: ItemLayoutProps) {
	const { t } = useSettings();

	const avatar = (
		<ImageAvatar
			dimensions={44}
			module="users"
			uid={props.model.coms_user_created_uid}
			avatar={props.model.user_created_avatar}
			initials={props.model.coms_title_initials}
		/>
	);

	return (
		<GridListItem avatar={avatar} buttons={buttons.view?.itemButtons}>
			<Grid container justifyContent="space-between" spacing={1}>
				<Grid size={{ xs: props.width >= 720 ? 8 : 12 }}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* WARNING */}
							{props.model.coms_warning_desc && (
								<Tooltip title={props.model.coms_warning_desc} arrow>
									<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
								</Tooltip>
							)}
							{/* BLOCKED */}
							{props.model.coms_blocked_desc && (
								<Tooltip title={props.model.coms_blocked_desc} arrow>
									<Icon className="mr-2" icon="block" color="error.main" />
								</Tooltip>
							)}
							{/* TITLE */}
							<Text
								className="font-600"
								variant="subtitle2"
								to={{ module: 'communications', uid: props.model.coms_uid }}
							>
								{props.model.coms_title}
							</Text>
						</Grid>
						{!props.model.coms_active && (
							<Grid>
								{/* ACTIVE */}
								<SquareChip
									icon={<Icon icon="eye-off" size={18} />}
									label={t('IS_HIDDEN')}
									backgroundColor={theme => theme.palette.warning.main}
								/>
							</Grid>
						)}
						<Grid>
							{/* DATE FROM - TO */}
							<SquareChip
								label={
									<FormattedDateTimeRange
										from={props.model.coms_d_from}
										to={props.model.coms_d_to}
										displayTime
									/>
								}
							/>
						</Grid>
						<Grid>
							{/* VISIBILITY */}
							<SquareChip
								label={
									<FormattedMessage
										id="deleteDialog.title"
										defaultMessage={t('VISIBILITY_LEVEL')}
										values={{ level: t(`${props.model.coms_visibility}_LEVEL_TITLE`) }}
									/>
								}
							/>
						</Grid>
						<Grid>
							{/* TAGS */}
							<TagsArray tags={props.model.coms_tags} changeFilter={props.changeFilter} />
						</Grid>
					</Grid>
				</Grid>
				{props.width >= 720 && (
					<Grid size={4}>
						{/* USER CREATED */}
						<ButtonLink
							href={`/users/details/${props.model.coms_user_created_uid}`}
							icon="account-circle"
							fallback={t('VIEW_ITEM_NO_INTREF')}
						>
							{props.model.user_created_title}
						</ButtonLink>
					</Grid>
				)}
			</Grid>
		</GridListItem>
	);
}
